import {
  BiodigestateApplicationEvent1Payload,
  BiosolidsApplicationEvent1Payload,
  CompostApplicationEvent1Payload,
  FERTILIZER_TOTAL_AMOUNT_UNIT,
  FERTILIZER_TYPES,
  FertilizerEventPostPutBody,
  LimeApplicationEvent1Payload,
  NITROGEN_FERTILIZER_TYPE,
  ORGANIC_FERTILIZER_ANIMAL_TYPES,
  ORGANIC_FERTILIZER_APPLICATION_METHOD,
  ORGANIC_FERTILIZER_TYPES,
  OrganicFertilizerApplicationEvent1Payload,
  OtherApplicationEvent1Payload,
  SyntheticFertilizerApplicationEvent1Payload,
} from "model";

export type OrganicFertilizerApplicationEvent = {
  isImported: boolean;
  organicFertilizerType: ORGANIC_FERTILIZER_TYPES;
  animalType: ORGANIC_FERTILIZER_ANIMAL_TYPES[];
  applicationMethod: ORGANIC_FERTILIZER_APPLICATION_METHOD;
};

export type SyntheticFertilizerApplicationEvent = {
  productName: string;
  nPercentage: number;
  typeOfNitrogen: NITROGEN_FERTILIZER_TYPE;
  pPercentage?: number;
  kPercentage?: number;
};

export type LimeApplicationEvent = {
  phPriorToApplication: number;
};

export type AnyOtherFertilizerEvent = Record<string, never>;

export type FertilizerEventFormData = {
  note?: string;
  totalAmount: number;
  totalAmountUnit: FERTILIZER_TOTAL_AMOUNT_UNIT;
  fertilizerApplicationDate: Date;
  fertilizerType: FERTILIZER_TYPES;
  fieldGuids: string[];
  fertilizerProperties:
    | OrganicFertilizerApplicationEvent
    | SyntheticFertilizerApplicationEvent
    | LimeApplicationEvent
    | AnyOtherFertilizerEvent;
};
export const convertFromFormInput = (
  fertilizerEventFormData: FertilizerEventFormData
): FertilizerEventPostPutBody => {
  let fertilizerProperties = {};
  if (fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.SYNTHETIC) {
    const syntheticFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as SyntheticFertilizerApplicationEvent;
    fertilizerProperties = {
      kPercentage: syntheticFertilizerProperties.kPercentage
        ? syntheticFertilizerProperties.kPercentage / 100
        : undefined,
      nPercentage: syntheticFertilizerProperties.nPercentage / 100,
      pPercentage: syntheticFertilizerProperties.pPercentage
        ? syntheticFertilizerProperties.pPercentage / 100
        : undefined,
      productName: syntheticFertilizerProperties.productName,
      typeOfNitrogen: syntheticFertilizerProperties.typeOfNitrogen,
    };
  } else if (
    fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.ORGANIC
  ) {
    const organicFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as OrganicFertilizerApplicationEvent;
    fertilizerProperties = {
      animalType: organicFertilizerProperties.animalType,
      applicationMethod: organicFertilizerProperties.applicationMethod,
      isImported: organicFertilizerProperties.isImported,
      organicFertilizerType: organicFertilizerProperties.organicFertilizerType,
    };
  } else if (fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.LIME) {
    const limeFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as LimeApplicationEvent;
    fertilizerProperties = {
      phPriorToApplication: limeFertilizerProperties.phPriorToApplication,
    };
  }
  return {
    note: fertilizerEventFormData.note,
    fertilizerProperties: {
      ...fertilizerProperties,
      fertilizerType: fertilizerEventFormData.fertilizerType,
    } as
      | OrganicFertilizerApplicationEvent1Payload
      | SyntheticFertilizerApplicationEvent1Payload
      | LimeApplicationEvent1Payload
      | BiosolidsApplicationEvent1Payload
      | BiodigestateApplicationEvent1Payload
      | CompostApplicationEvent1Payload
      | OtherApplicationEvent1Payload,
    fertilizerApplicationDate: new Date(
      fertilizerEventFormData.fertilizerApplicationDate
    ).toISOString(),
    fieldGuids: fertilizerEventFormData.fieldGuids,
    totalAmount: fertilizerEventFormData.totalAmount,
    totalAmountUnit: fertilizerEventFormData.totalAmountUnit,
  };
};
